module.exports = __webpack_public_path__ + "static/img/not-400.fde3ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/not-400.png
// module id = SNiP
// module chunks = 101